import Client from '../HttpClient';

const baseUrl = '/gateway/eagle-mgt/api/vs/manager';

const list = (merchantId, branchId, type) => {
	return Client.get(`${baseUrl}/${merchantId}/depositSettings`, {
		branchId,
		type,
	});
};

const find = (merchantId, branchId, id) => {
	return Client.get(`${baseUrl}/${merchantId}/depositSettings/${id}`, {
		branchId,
	});
};

const create = (
	merchantId,
	branchId,
	min,
	value,
	type,
	depositPayType,
	operateBy
) => {
	return Client.post(`${baseUrl}/${merchantId}/depositSettings`, {
		branchId,
		depositPayType,
		type,
		min,
		value,
		operateBy,
	});
};

const update = (
	merchantId,
	branchId,
	id,
	min,
	value,
	type,
	depositPayType,
	operateBy
) => {
	return Client.put(`${baseUrl}/${merchantId}/depositSettings/${id}`, {
		branchId,
		depositPayType,
		type,
		min,
		value,
		operateBy,
		stopFlag: false,
	});
};

const remove = (merchantId, branchId, id, operateBy) => {
	return Client.del(`${baseUrl}/${merchantId}/depositSettings/${id}`, {
		branchId,
		operateBy,
	});
};

export default {
	list,
	find,
	create,
	update,
	remove,
};
